// extracted by mini-css-extract-plugin
module.exports = {"ButtonInput":"_1O-bi"};